import React, { useState } from 'react';
import api from '../lib/api';
import { useNavigate, Link, useLocation } from 'react-router-dom';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = (location.state as any)?.from;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      const response = await api.post('/auth/register', { name, email, password });
      console.log(response.data);
      setSuccess('Registrace proběhla úspěšně! Za chvíli budete přesměrováni na přihlášení...');
      setTimeout(() => navigate('/login', { state: { from: redirectTo } }), 2000);
    } catch (error: any) {
      console.error(error);
      setError(error.response?.data?.error || 'Registrace se nezdařila. Zkuste to prosím znovu.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-primary-50 via-secondary-50 to-accent-50 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-10 right-20 w-72 h-72 bg-accent-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-float"></div>
        <div className="absolute bottom-10 left-20 w-96 h-96 bg-primary-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-float" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative w-full max-w-md animate-fade-in">
        <div className="bg-white/80 backdrop-blur-lg p-8 sm:p-10 space-y-6 sm:space-y-8 rounded-3xl shadow-card-hover border border-white">
          <div className="text-center">
            <div className="text-6xl mb-4 animate-bounce-slow">🎯</div>
            <h2 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-primary-600 to-accent-600 bg-clip-text text-transparent">
              Přidejte se do hry!
            </h2>
            <p className="mt-2 text-gray-600">Vytvořte si účet a začněte hrát</p>
          </div>

          {error && (
            <div className="p-4 text-sm text-red-700 bg-red-50 rounded-2xl border border-red-200 animate-slide-up">
              <span className="mr-2">⚠️</span>
              {error}
            </div>
          )}

          {success && (
            <div className="p-4 text-sm text-green-700 bg-green-50 rounded-2xl border border-green-200 animate-slide-up">
              <span className="mr-2">✅</span>
              {success}
            </div>
          )}

          <form className="space-y-5 sm:space-y-6" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                👤 Celé jméno
              </label>
              <input
                type="text"
                required
                className="w-full p-4 text-gray-900 bg-white rounded-2xl border-2 border-gray-200 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-100 transition-all duration-300"
                placeholder="Jan Novák"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                📧 E-mailová adresa
              </label>
              <input
                type="email"
                required
                className="w-full p-4 text-gray-900 bg-white rounded-2xl border-2 border-gray-200 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-100 transition-all duration-300"
                placeholder="uzivatel@email.cz"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                🔒 Heslo
              </label>
              <input
                type="password"
                required
                className="w-full p-4 text-gray-900 bg-white rounded-2xl border-2 border-gray-200 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-100 transition-all duration-300"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="w-full py-4 font-bold text-white bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl shadow-lg hover:shadow-glow hover:scale-105 transform transition-all duration-300"
            >
              Vytvořit účet 🚀
            </button>
          </form>

          <div className="text-center">
            <p className="text-gray-600">
              Už máte účet?{' '}
              <Link
                to="/login"
                state={{ from: redirectTo }}
                className="font-bold text-primary-600 hover:text-secondary-600 transition-colors"
              >
                Přihlaste se zde
              </Link>
            </p>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="text-primary-600 hover:text-secondary-600 font-semibold transition-colors">
            ← Zpět na úvod
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
